import { SUCCESS_LOADING_RELATED_CONTACTS } from '../../constants'

const initialState = {};

export default (state = initialState, action) => {
  switch(action.type){
    case SUCCESS_LOADING_RELATED_CONTACTS:
      return Object.assign({}, state, {
        [action.filter || 'all'] : action.payload.result.objects
      });

    default:
      return state;
  }
};